export default __webpack_public_path__ + "locales/fr/PreparationPortal.json?hash=4bd79a05ad35450e2564f19c466615bb";